import { useMutation } from 'react-query';

import { axios } from '@/lib/axios';

type createFolderType = {
  direction: string;
  crossingRequestedDate: string;
};

const initPreFolder = ({ direction, crossingRequestedDate }: createFolderType) => {
  const body = {
    borderCrossingServiceId: '0C2FAEB0-36D6-4F19-BEC2-76AFF641C44E',
    carrierReferenceId: String(new Date().getTime()),
    direction,
    tractorVrn: 'AB745CD',
    trailerVrn: 'EF942GH',
    crossingRequestedDate,
  };

  return axios.post<{ redirectionUrl: string }>('/pre-folders', body);
};

export const useInitPreFolder = () =>
  useMutation({
    mutationFn: initPreFolder,
    onSuccess({ data: { redirectionUrl } }) {
      window.open(redirectionUrl, '_blank');
    },
  });
